// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as LatLng$PorterinFeature from "../../../../domain/entity/LatLng.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as EditOrderReviewAddressModuleScss from "../styles/EditOrderReviewAddress.module.scss";
import UsePlacesAutocompleteServiceJs from "react-google-autocomplete/lib/usePlacesAutocompleteService.js";

var styles = EditOrderReviewAddressModuleScss;

function GoogleAddressAutoCompleteCmp(Props) {
  var id = Props.id;
  var value = Props.value;
  var api_key = Props.api_key;
  var form_on_change = Props.form_on_change;
  var placeholder = Props.placeholder;
  var on_focus = Props.on_focus;
  var on_blur = Props.on_blur;
  var prediction_array = Props.prediction_array;
  var set_prediction_array = Props.set_prediction_array;
  var match = React.useState(function () {
        return [];
      });
  var setPredictedArray = match[1];
  var mapInst = document.getElementById("map");
  var categoryInputRef = React.useRef(null);
  var serviceResponse = UsePlacesAutocompleteServiceJs({
        apiKey: api_key,
        debounce: 300,
        options: {
          componentRestrictions: {
            country: "IND"
          }
        }
      });
  React.useEffect((function () {
          JsBindings$PorterinUtils.setAddressAutoFillOff("custom-autocomplete-" + id);
        }), [mapInst]);
  React.useEffect((function () {
          if (serviceResponse.placePredictions.length !== 0) {
            var predictedArray = serviceResponse.placePredictions;
            Curry._1(setPredictedArray, (function (param) {
                    return predictedArray;
                  }));
          }
          
        }), [serviceResponse.placePredictions]);
  React.useEffect((function () {
          if (serviceResponse.placePredictions.length === 0 && prediction_array.length === 0) {
            
          } else {
            Curry._1(set_prediction_array, serviceResponse.placePredictions);
          }
        }), [serviceResponse.placePredictions]);
  return React.createElement("input", {
              ref: categoryInputRef,
              className: styles["input-styles"],
              id: id,
              placeholder: placeholder,
              value: value,
              onFocus: (function ($$event) {
                  if ($$event.target.value === "") {
                    Curry._1(set_prediction_array, []);
                  }
                  Curry._1(on_focus, undefined);
                }),
              onBlur: (function ($$event) {
                  Curry._1(on_blur, undefined);
                }),
              onChange: (function ($$event) {
                  Curry._2(form_on_change, {
                        landmark: $$event.target.value,
                        location: LatLng$PorterinFeature.initial_lat_lng(undefined)
                      }, {
                        pincode: undefined,
                        state: undefined,
                        city: undefined,
                        locality: undefined,
                        sub_locality: undefined
                      });
                  if ($$event.target.value.length >= 2) {
                    return Curry._1(serviceResponse.getPlacePredictions, {
                                input: $$event.target.value
                              });
                  } else {
                    return Curry._1(set_prediction_array, []);
                  }
                })
            });
}

var make = GoogleAddressAutoCompleteCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
